// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__3y4e6","article__body":"Article_article__body__2YsGt"};